module.exports = __webpack_public_path__ + "static/media/harvest.92889623.svg";